import pattern from '../../assets/images/pattern.jpg'

export default function Topbar({data}){
    return(
        <header className="py-4" style={{backgroundImage: `url(${pattern})`}}>
            <div className="container px-4 px-lg-5 my-5">
                <div className="text-center text-black">
                    <h1 className="display-4 fw-bolder mb-3">{data.name}</h1>
                    {
                        data.ProductCategories && data.ProductCategories.map((value,index) => 
                        <div className="d-inline lead fw-normal text-black-50 mb-0 me-2 border p-1" key={index}>{value.name}</div>
                    )}
                </div>
            </div>
        </header>
    )
}